export interface IConfigureMetaLeadsRequest {
	adAccountIds: string[];
	pageIds: string[];
}

export interface IMetaPage {
	id: string;
	name: string;
	category?: string;
}

export interface IOAuthLinkSystemJob {
	id: string;
	userId?: string;
	accountId?: string;
	dateCreatedUtc?: string;
	dateLastUpdatedUtc?: string;
	percentComplete?: number;
	authUrl: string;
	redirectBaseUrl?: string;
}

export interface IMetaAdAccountBusiness {
	id: string;
	name: string;
}

export interface IMetaAdAccount {
	id: string;
	name: string;
	externalAccountId?: string;
	accountStatus?: number;
	businessName?: string;
	business?: IMetaAdAccountBusiness;
}

/** Why Meta rejected a Facebook/Instagram/Meta Ads user token. Serialized as the member name; absent or null means healthy. */
export enum MetaAuthFailureReason {
	/** Meta paused the Facebook account until the user completes a security check on facebook.com. */
	CheckpointRequired = 'CheckpointRequired',
	/** The Facebook account has not been confirmed yet. */
	AccountUnconfirmed = 'AccountUnconfirmed',
	/** The user changed their Facebook password, which invalidated the token. */
	PasswordChanged = 'PasswordChanged',
	/** The token reached its expiry. */
	TokenExpired = 'TokenExpired',
	/** The user removed Levitate's app access in their Facebook settings. */
	AppRemoved = 'AppRemoved',
	/** Meta ended the session for any other or unspecified reason. */
	SessionInvalidated = 'SessionInvalidated',
}

export interface IMetaAdsConnection {
	id: string;
	enabled: boolean;
	connectedAt?: string;
	connectedByUserId?: string;
	lastPollTimestamp?: string;
	lastPollLeadCount?: number;
	lastPollError?: string;
	lastLeadReceivedAt?: string;
	adAccountIds?: string[];
	pageIds?: string[];
	/** Why Meta rejected the connection's token. Only set while the connection is enabled. */
	reconnectReason?: MetaAuthFailureReason | null;
}

// Meta Ads Reporting Types

export interface IMetaAd {
	id: string;
	name: string;
	status: string;
	effectiveStatus: string;
	campaignId: string;
	campaignName: string;
	adsetId: string;
}

export interface IMetaAdsSummary {
	currency: string;
	spend: number;
	impressions: number;
	clicks: number;
	leads: number;
	costPerLead: number;
	clickThroughRate: number;
}

export interface IMetaAdsDailyMetrics {
	date: string;
	spend: number;
	impressions: number;
	clicks: number;
	leads: number;
	costPerLead: number;
	clickThroughRate: number;
}

export interface IMetaAdMetricsSummary {
	adExternalId: string;
	adName: string;
	campaignId: string;
	campaignName: string;
	campaignObjective: string;
	spend: number;
	impressions: number;
	clicks: number;
	leads: number;
	costPerLead: number;
	clickThroughRate: number;
}

export interface IMetaCampaignMetricsSummary {
	campaignId: string;
	campaignName: string;
	campaignObjective?: string;
	spend: number;
	impressions: number;
	clicks: number;
	leads: number;
	costPerLead: number;
	clickThroughRate: number;
	adCount: number;
	ads: IMetaAdMetricsSummary[];
}
